export default __webpack_public_path__ + "static/media/logo_without_border_design.ab0954df.png";